import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);


function getHistoryTracking(params) {
	return client.get("public/tracking/get-history-tracking", {
		params: params,
	});
}

function getTrackingKiriminaja(params) {
	return client.get("expka/tracking/get-tracking-trx", {
		params: params,
	});
}

function getTracking(params) {
	return client.get("public/tracking/get-tracking", {
		params: params,
	});
}

function getStatusPesanan(params) {
	return client.get("seller/trx/data-status", {
		params: params,
	});
}

function getPesanan(params) {
	return client.get("seller/trx/data", {
		params: params,
	});
}

function getPaidPesanan(params) {
	return client.get("seller/trx/data-paid", {
		params: params,
	});
}

function getPesananDetail(params) {
	return client.get("seller/trx/detail", {
		params: params,
	});
}

function getPesananDetailShipment(params) {
	return client.get("seller/trx/detail-shipment", {
		params: params,
	});
}
function prosesPesanan(params) {
	return client.post("seller/trx/process", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function cancelPesanan(params) {
	return client.post("seller/trx/cancel", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function requestPickupPesanan(params) {
	return client.post("seller/trx/request-pickup-courier", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function kirimPesanan(params) {
	return client.post("seller/trx/deliver", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function paymentStorePaid(params) {
	return client.post("seller/trx/payment-store-paid", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function paymentStoreCancel(params) {
	return client.post("seller/trx/payment-store-cancel", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function pickupStore(params) {
	return client.post("seller/trx/pick-up", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function changeResi(params) {
	return client.post("seller/trx/change-resi", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getAlamatDetail(params) {
	return client.get("user/address/detail", {
		params: params,
	});
}

export default {
	getStatusPesanan,
	getPesanan,
	getPaidPesanan,
	getPesananDetail,
	prosesPesanan,
	kirimPesanan,
	paymentStorePaid,
	paymentStoreCancel,
	pickupStore,
	changeResi,
	getAlamatDetail,
	getTracking,
	getHistoryTracking,
	cancelPesanan,
	requestPickupPesanan,
	getPesananDetailShipment,
	getTrackingKiriminaja
};